import { Field } from "formik";
import React from "react";
import { Input, Select } from "../../../../../../_metronic/_partials/controls";
import { CLASSIFICATION_ARRAY } from "../OrganizationUIHelpers";
import AsyikSelect from "react-select/async";
import { genOptionLoaderDebounced } from "../../../../../../_metronic/_helpers/fetchUtils";
import { findOrganizationClassification } from "../../../_redux/organization-classification/organizationClassificationCrud";
import ReactSelect from "react-select";
import { findOrganizationCategory } from "../../../_redux/organization-category/organizationCategoryCrud";

export default function OrganizationEditDataForm({
  inputOptions,
  setFieldValue,
  values
}) {
  return (
    <>
      <div className="form-group row">
        <div className="col">
          <Field
            name="name"
            placeholder="Nama Lembaga"
            label="Nama Lembaga"
            component={Input}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col">
          <Field
            name="user.name"
            placeholder="Nama PIC"
            label="Nama PIC"
            component={Input}
          />
        </div>
      </div>
      {/* <div className="form-group row">
        <div className="col">
          <label>
            <strong>Klasifikasi Lembaga</strong>
          </label>
          <Select className="form-control" name="classification_organization">
            {CLASSIFICATION_ARRAY.map(item => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </Select>
        </div>
      </div> */}
      <div className="form-group row">
        <div className="col">
          <label>
            <strong>Klasifikasi Lembaga</strong>
          </label>
          <AsyikSelect
            defaultOptions={inputOptions.org_classification.map(
              ({ name, uuid }) => ({ label: name, value: uuid })
            )}
            loadOptions={genOptionLoaderDebounced(
              inputValue =>
                findOrganizationClassification({
                  pageNumber: 1,
                  pageSize: 10,
                  filter: {
                    name: inputValue
                  }
                }),
              ({ uuid, name }) => ({ label: name, value: uuid })
            )}
            value={
              values.organization_classification_uuid
                ? {
                    label: values.organization_classification_name,
                    value: values.organization_classification_uuid
                  }
                : null
            }
            placeholder="Pilih Klasifikasi Lembaga..."
            onChange={selected => {
              const { label = "", value = "" } = selected ?? {};

              setFieldValue("organization_classification_name", label);
              setFieldValue("organization_classification_uuid", value);
            }}
            isClearable
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col">
          <label>
            <strong>Regional</strong>
          </label>
          <ReactSelect
            name="organization_regional"
            options={inputOptions.org_regional.map(item => ({
              label: item.name,
              value: item.uuid
            }))}
            value={{
              label: values.organization_regional_name,
              value: values.organization_regional_uuid
            }}
            onChange={e => {
              const value = e && e.value;
              const label = e && e.label;
              setFieldValue("organization_regional_name", label);
              setFieldValue("organization_regional_uuid", value);
            }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col">
          <label>
            <strong>Kategori Lembaga</strong>
          </label>
          <AsyikSelect
            defaultOptions={inputOptions.org_category.map(({ name, uuid }) => ({
              label: name,
              value: uuid
            }))}
            loadOptions={genOptionLoaderDebounced(
              inputValue =>
                findOrganizationCategory({
                  pageNumber: 1,
                  pageSize: 10,
                  filter: {
                    name: inputValue
                  }
                }),
              ({ uuid, name }) => ({ label: name, value: uuid })
            )}
            value={
              values.organization_category_uuid
                ? {
                    label: values.organization_category_name,
                    value: values.organization_category_uuid
                  }
                : null
            }
            placeholder="Pilih Kategori Lembaga..."
            onChange={selected => {
              const { label = "", value = "" } = selected ?? {};

              setFieldValue("organization_category_name", label);
              setFieldValue("organization_category_uuid", value);
            }}
            isClearable
          />
        </div>
      </div>
    </>
  );
}
